/* eslint-disable import/prefer-default-export */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AccountMappingPayload } from "api/models";
import { createAccountMappings } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useCreateAccountMappings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AccountMappingPayload[]) => createAccountMappings(payload).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries(userQueryKeys.accountMappings({}).slice(0, 1));
    },
  });
}
